import { render, staticRenderFns } from "./ApprovalGroupSelectCheckBoxes.vue?vue&type=template&id=3a766358"
import script from "./ApprovalGroupSelectCheckBoxes.vue?vue&type=script&lang=ts"
export * from "./ApprovalGroupSelectCheckBoxes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports